import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { decodeState } from '@blisspointmedia/bpm-types/dist/AmazonSPAPI';
import { useSetError } from '@src/redux/modals';
import { AmazonLambdaFetch } from '@src/utils/fetch-utils';

/**
 * This is a dummy component that will redirect from the Amazon callback to
 * the Retail Ops Channels page after generating a refresh token.
 */
export const AmazonRedirect = () => {
  const setError = useSetError();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      // Check for URL paramters after redirect back from Amazon. If they exist, hit the lambda to generate and store a new refresh token.
      const params = new URLSearchParams(window.location.search);
      const authCode = params.get('spapi_oauth_code');
      const state = params.get('state');

      if (!authCode || !state) {
        console.error('Missing required auth parameters');
      }

      const { company, applicationType, marketplace, brand } = decodeState(state || '');

      // Without a company in the state, the account would be saved with company=''.
      if (!company) {
        setError({ message: 'Amazon authorization failed: no company in the callback state.' });
        navigate('/', { replace: true });
        return;
      }

      try {
        if (authCode) {
          await AmazonLambdaFetch('/generateRefreshToken', {
            method: 'POST',
            body: JSON.stringify({
              company,
              authCode,
              applicationType,
              marketplace,
              brand
            })
          });
        }
      } catch (e) {
        setError({
          message: `Failed to generate refresh token: ${e.message}`,
          reportError: e
        });
      }

      navigate(`/${company}/retail-ops-channels`, { replace: true });
    })();
  }, [navigate, setError]);

  return null;
};
